import React from 'react'
import { PieChart, Pie, Cell } from 'recharts';

const PiePage = ({ totalPage, currentPage, heading }) => {
    const Percentage = (currentPage / totalPage) * 100
    const chartData = [
        { name: '', value: Percentage },
        { name: '', value: (100 - Percentage) }
    ]
    return (
        <div className='col-sm-12 col-xs-12 chart-main-page'>
            <PieChart width={50} height={50}>
                <Pie
                    data={chartData}
                    cx={20}
                    cy={20}
                    innerRadius={18}
                    outerRadius={23}
                    startAngle={450}
                    endAngle={90}
                    fill="#8884d8"
                    paddingAngle={0}
                    dataKey="value"
                >
                    <Cell fill={'#057350'} />
                    <Cell fill={'#DDDFE5'} />
                </Pie>
            </PieChart>
            <div className="page-counts">{currentPage + '/' + totalPage}</div>
            <div>
                {/* <b style={{ fontSize: '12px' }}>{requestALoan}</b> */}
                <p className='step-heading' style={{ textTransform: 'capitalize' }}>{heading}</p>
            </div>
        </div>
    )
}

export default PiePage;